import script from "./RegisterSuccessPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSuccessPage.vue?vue&type=script&setup=true&lang=js"

import "./RegisterSuccessPage.vue?vue&type=style&index=0&id=66896c7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66896c7e"]])

export default __exports__